import React, {useState} from "react";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {Calendar} from "primereact/calendar";
import Button from "../common/botton/Button";
import {InputTextarea} from "primereact/inputtextarea";
import {AppApi} from "../AppApi";
import {createSearchParams} from "react-router";
import {useNavigate} from "react-router-dom";
import {InputMask} from "primereact/inputmask";
import PanelForm from "../panel/Form";
import ListItem from "../trip/ListItem";

export default function DialogForm(props) {

    const navigate = useNavigate();
    const [email, setEmail] = useState();
    const [comment, setComment] = useState();
    const [countOfParticipants, setCountOfParticipants] = useState(1);


    const [participant1, setParticipant1] = useState({
        firstName: null,
        lastName: null,
        dateOfBirth: null
    });

    const [participant2, setParticipant2] = useState({
        firstName: null,
        lastName: null,
        dateOfBirth: null
    });

    const [participant3, setParticipant3] = useState({
        firstName: null,
        lastName: null,
        dateOfBirth: null
    });

    const [participant4, setParticipant4] = useState({
        firstName: null,
        lastName: null,
        dateOfBirth: null
    });

    const [participant5, setParticipant5] = useState({
        firstName: null,
        lastName: null,
        dateOfBirth: null
    });

    function postBookingRequest() {
        let bookingRequest = {
            tripId: props.trip.id,
            appointmentDate: props.appointment.date,
            email: email,
            participants: [],
            comment: comment
        }

        bookingRequest.participants = []
        if(countOfParticipants >= 1){
            bookingRequest.participants.push(participant1)
        }
        if(countOfParticipants >= 2){
            bookingRequest.participants.push(participant2)
        }
        if(countOfParticipants >= 3){
            bookingRequest.participants.push(participant3)
        }
        if(countOfParticipants >= 4){
            bookingRequest.participants.push(participant4)
        }
        if(countOfParticipants >= 5){
            bookingRequest.participants.push(participant5)
        }
        AppApi.pub.postBookingRequest(bookingRequest)
            .then(response => {
                navigate({
                    pathname: '/bookings/',
                    search: `?${createSearchParams({email: response.data.email, code: response.data.code})}`
                })
            })
            .catch(console.log)
    }

    if (props.trip) {
        return (

            <PanelForm style={{background: '#FFFFFF', padding: 15}}>
                <div className="flex flex-wrap" style={{justifyContent: 'right'}}>

                    <div>
                        <Button
                            style={{width: 40, borderRadius: 45, background: 'red', border: '1px solid darkred'}}
                            icon={<i className="pi pi-times"/>}
                            onClick={() => props.onHide()}
                        />
                    </div>
                </div>

                <div className="flex flex-wrap" style={{justifyContent: 'center'}}>

                    {false && (
                        <div style={{width: '100%', textAlign: 'center', padding: '10px 0 30px 0'}}>
                            <div style={{display: 'inline-block', padding: '0 20px'}}>
                                <div style={{ display: 'inline-block', borderRadius: 45, background: '#86b850', width: 40, height: 40, fontSize: 28}}>1</div>
                                <div style={{ paddingLeft: 5, display: 'inline-block', borderRadius: 45, height: 40, fontSize: 30}}> Deine Angaben</div>
                            </div>
                            <div style={{display: 'inline-block', padding: '0 20px'}}>
                                <div style={{ display: 'inline-block', borderRadius: 45, background: '#cfe1bc', width: 40, height: 40, fontSize: 28}}>2</div>
                                <div style={{ paddingLeft: 5, display: 'inline-block', borderRadius: 45, height: 40, fontSize: 30}}> Prüfung & Rückmeldung</div>
                            </div>
                            <div style={{display: 'inline-block', padding: '0 20px'}}>
                                <div style={{ display: 'inline-block', borderRadius: 45, background: '#cfe1bc', width: 40, height: 40, fontSize: 28}}>3</div>
                                <div style={{ paddingLeft: 5, display: 'inline-block', borderRadius: 45, height: 40, fontSize: 30}}> Kurs Buchen</div>
                            </div>
                        </div>
                    )}

                    <div style={{width: 360, margin: '0 20px'}}>
                        <h1>Unverbindliche Anfrage stellen</h1>
                        <div style={{padding: 10}}>
                            Bitte fülle das folgende Formular aus, um unverbindlich Kontakt aufzunehmen. Je mehr Informationen Du teilst, desto besser können wir Dir weiterhelfen.
                        </div>
                        <ListItem trip={{...props.trip, appointmentDate: props.appointment?.date}}/>
                    </div>

                    <div style={{background: '#FFFFFF', padding: 15, maxWidth: '450px'}}>

                        <div className="flex flex-column gap-2 pt-4">
                            <b><label htmlFor="email">E-Mail:</label></b>
                            <InputText
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}/>
                        </div>

                        <div className="flex flex-column gap-2 pt-4">
                            <b><label htmlFor="username">Für wie viele Personen möchtest Du anfragen:</label></b>
                            <InputNumber
                                value={countOfParticipants}
                                onValueChange={(e: InputNumberValueChangeEvent) => setCountOfParticipants(e.value)}
                                showButtons
                                buttonLayout="horizontal"
                                step={1}
                                decrementButtonClassName="p-button-danger"
                                incrementButtonClassName="p-button-success"
                                incrementButtonIcon="pi pi-plus"
                                decrementButtonIcon="pi pi-minus"
                                mode="decimal"
                                showButtons
                                min={1}
                                max={5} />
                        </div>
                        <br/>
                        <table>
                            <thead>
                            <th style={{textAlign: 'left'}}>Vorname:</th>
                            <th style={{textAlign: 'left'}}>Nachname:</th>
                            <th style={{textAlign: 'left'}}>Geburtdatum:</th>
                            </thead>
                            <tbody>
                            {countOfParticipants >= 1 && (
                                <tr>
                                    <td>
                                        <InputText
                                            style={{width: '100%'}}
                                            id="firstName"
                                            value={participant1.firstName}
                                            onChange={(e) => setParticipant1({...participant1, firstName: e.target.value})}/>
                                    </td>
                                    <td>
                                        <InputText
                                            style={{width: '100%'}}
                                            id="lastName"
                                            value={participant1.lastName}
                                            onChange={(e) => setParticipant1({...participant1, lastName: e.target.value})}/>
                                    </td>
                                    <td>
                                        <InputMask
                                            style={{width: '100%'}}
                                            value={participant1.dateOfBirth}
                                            onChange={(e) => setParticipant1({...participant1, dateOfBirth: e.target.value})}
                                            mask="99.99.9999"
                                            placeholder="dd.mm.yyyy"
                                            slotChar="dd-mm-yyyy" />
                                    </td>
                                </tr>
                            )}

                            {countOfParticipants >= 2 && (
                                <tr>
                                    <td>
                                        <InputText
                                            style={{width: '100%'}}
                                            id="firstName"
                                            value={participant2.firstName}
                                            onChange={(e) => setParticipant2({...participant2, firstName: e.target.value})}/>
                                    </td>
                                    <td>
                                        <InputText
                                            style={{width: '100%'}}
                                            id="lastName"
                                            value={participant2.lastName}
                                            onChange={(e) => setParticipant2({...participant2, lastName: e.target.value})}/>
                                    </td>
                                    <td>
                                        <InputMask
                                            style={{width: '100%'}}
                                            value={participant2.dateOfBirth}
                                            onChange={(e) => setParticipant1({...participant2, dateOfBirth: e.target.value})}
                                            mask="99.99.9999"
                                            placeholder="dd.mm.yyyy"
                                            slotChar="dd-mm-yyyy" />
                                    </td>
                                </tr>
                            )}

                            {countOfParticipants >= 3 && (
                                <tr>
                                    <td>
                                        <InputText
                                            style={{width: '100%'}}
                                            id="firstName"
                                            value={participant3.firstName}
                                            onChange={(e) => setParticipant3({...participant3, firstName: e.target.value})}/>
                                    </td>
                                    <td>
                                        <InputText
                                            style={{width: '100%'}}
                                            id="lastName"
                                            value={participant3.lastName}
                                            onChange={(e) => setParticipant3({...participant3, lastName: e.target.value})}/>
                                    </td>
                                    <td>
                                        <InputMask
                                            style={{width: '100%'}}
                                            value={participant3.dateOfBirth}
                                            onChange={(e) => setParticipant1({...participant3, dateOfBirth: e.target.value})}
                                            mask="99.99.9999"
                                            placeholder="dd.mm.yyyy"
                                            slotChar="dd-mm-yyyy" />
                                    </td>
                                </tr>
                            )}

                            {countOfParticipants >= 4 && (
                                <tr>
                                    <td>
                                        <InputText
                                            style={{width: '100%'}}
                                            id="firstName"
                                            value={participant4.firstName}
                                            onChange={(e) => setParticipant4({...participant4, firstName: e.target.value})}/>
                                    </td>
                                    <td>
                                        <InputText
                                            style={{width: '100%'}}
                                            id="lastName"
                                            value={participant4.lastName}
                                            onChange={(e) => setParticipant4({...participant4, lastName: e.target.value})}/>
                                    </td>
                                    <td>
                                        <InputMask
                                            style={{width: '100%'}}
                                            value={participant4.dateOfBirth}
                                            onChange={(e) => setParticipant1({...participant4, dateOfBirth: e.target.value})}
                                            mask="99.99.9999"
                                            placeholder="dd.mm.yyyy"
                                            slotChar="dd-mm-yyyy" />
                                    </td>
                                </tr>
                            )}

                            {countOfParticipants >= 5 && (
                                <tr>
                                    <td>
                                        <InputText
                                            style={{width: '100%'}}
                                            id="firstName"
                                            value={participant5.firstName}
                                            onChange={(e) => setParticipant5({...participant5, firstName: e.target.value})}/>
                                    </td>
                                    <td>
                                        <InputText
                                            style={{width: '100%'}}
                                            id="lastName"
                                            value={participant5.lastName}
                                            onChange={(e) => setParticipant5({...participant5, lastName: e.target.value})}/>
                                    </td>
                                    <td>
                                        <InputMask
                                            style={{width: '100%'}}
                                            value={participant4.dateOfBirth}
                                            onChange={(e) => setParticipant5({...participant5, dateOfBirth: e.target.value})}
                                            mask="99.99.9999"
                                            placeholder="dd.mm.yyyy"
                                            slotChar="dd-mm-yyyy" />
                                    </td>
                                </tr>
                            )}

                            </tbody>
                        </table>


                        <div className="flex flex-column gap-2 pt-4">
                            <b><label htmlFor="username">Fragen und Anmerkungen:</label></b>
                            <InputTextarea
                                value={comment}
                                onChange={(e) => setComment(e.target.value)} rows={5} cols={30} />
                        </div>
                        <br/>


                        <Button label="Anfragen" onClick={() => postBookingRequest()}/>


                        <div style={{padding: '10px 0px', textAlign: 'center'}}>
                            Es gelten unsere AGB, und wir weisen auf unseren Datenschutz hin.
                        </div>
                    </div>
                </div>



            </PanelForm>
        )
    }

}